// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2lQFP","large":"styles_large__iF-zI"};